export { UniProfileLinks } from "./../uni_profile_links";
export { TemTwoRanking } from "./tem_two_ranking";
export { TemTwoProfileMatching } from "./tem_two_profile_matching";
export { TemTwoScholarships } from "./tem_two_scholarships";
export { UniOverviewAccomodation } from "./../uni_overview/uni_overview_accomodation";
export { TemtwoImageGallery } from "./tem_two_image_gallery";
export { TemTwoCampus } from "./tem_two_campus";
export { LikeDislike } from "./like_dislike";
export { UniProfileUniBox } from "./../uni_profile_uni_box";
